import { useNavigate } from 'react-router-dom';
import { EditPage, EditPageTextField, EditPageCheckbox, EditPageSelect, EditPagePanel } from './../../../common/EditPage';
import { update, getOne } from './../../../common/v4/BackendProvider';
import { ToastContainer, toast } from 'react-toastify';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const InvoiceTemplateEdit = () => {
    const navigate = useNavigate();
    const [data, setData] = useState({});
    const [metadata, setMetadata] = useState({});
    const [defaultCurrency, setDefaultCurrency] = useState({});
    const { invoice_template_id } = useParams();
    useEffect(() => {
        getOne('/admin/settings/invoice_templates/', invoice_template_id).then(response => {
            setData(response.data.data);
        });
        getOne('/admin/settings/invoice_templates/', 'new').then(response => {
            setMetadata(response.data.metadata);
        });
    }, [invoice_template_id]);

    const handleSave = () => {
        update('/admin/settings/invoice_templates/', invoice_template_id, {data: data}).then(response => {
            toast.success("Invoice template updated successfully", {});
            navigate('/settings/invoice_templates');
        }).catch(error => {
            toast.error("Error updating invoice template: " + error.message, {});
        });
    }

    const handleCancel = () => {
        navigate('/settings/invoice_templates');
    }

    const onChange = (id, value) => {
        setData({ ...data, [id]: value });
    }

    return (
        <div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnHover={true}
                draggable={true}
                progress="undefined"
            />
            <EditPage handleSave={ handleSave } handleCancel={ handleCancel } title={`Update Invoice Template (${data.name})`} >
                <EditPagePanel>
                    <EditPageTextField label="Name" id="name" onChange={ onChange } value={ data.name } />
                    <EditPageTextField label="Description" id="description" onChange={ onChange } value={ data.description } />
                    <EditPageSelect label="Template Type" id="template" onChange={ onChange } value={ data.template } options={ metadata?.template_types?.values } />
                    <EditPageCheckbox label="Include Link to Usage" id="include_link_to_usage" onChange={ onChange } value={ data.include_link_to_usage } />
                </EditPagePanel>
            </EditPage>
        </div>
    )
}

export default InvoiceTemplateEdit;